export default {
    common: {
        email: '电邮',
        LoginBtn: '登录',
        SignUpBtn: '注册',
        SubmitBtn: '提交',
        ExitBtn: '退出',
        LogoutBtn: '登出'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: '请于电邮内查收验证码',
        VerificationCode: '验证码'
    },
    header: {
        OrderHistory: '订单记录',
        MYACCOUNT: '我的账户',
        WelcomeBack: '欢迎回来'
    },
    detail: {
        TotalOrders: '订单总数',
        TotalProducts: '产品总数',
        WonderlandPoints: 'Wonderland积分',
        APMCredits: 'APM积分',
        ExpireOn: '有效期限',
        NoAPMCredits: '暂无APM积分',
        CreditsLoading: '积分加载中'
    },
    panel: {},
    entry: {
        Client: '顾客',
        OrderDate: '订单日期',
        DeliverDate: '送达日期',
        Description: '描述',
        Total: '合计'
    },
    board: {
        Order: '订单',
        Date: '日期',
        Total: '合计'
    },
    order: {
        OrderID: '订单编号',
        PurchasePlace: '购买地点',
        PurchaseDate: '下单日期',
        TotalPrice: '总价',
    },
    product: {
        Name: '商品名称',
        SKU: '商品SKU',
        Size: '商品尺码',
        Quantity: '商品数量',
        Price: '商品价格',
        WarrantyUntil: '保修期至',
    }
}


// WEBPACK FOOTER //
// ./src/locales/sc/index.js